import createIcon from '../../createIcon';

/**
 * @component @name SnippetFolder
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuODggMTAuNUwxNy41IDEyLjEyVjE1LjVIMTQuNVYxMC41SDE1Ljg4Wk0yMiA4VjE4QzIyIDE5LjEgMjEuMSAyMCAyMCAyMEg0QzIuOSAyMCAyIDE5LjEgMiAxOEwyLjAxIDZDMi4wMSA0LjkgMi45IDQgNCA0SDEwTDEyIDZIMjBDMjEuMSA2IDIyIDYuOSAyMiA4Wk0xOSAxMS41TDE2LjUgOUgxM1YxN0gxOVYxMS41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SnippetFolder = createIcon('SnippetFolder', [
  [
    'path',
    {
      d: 'M15.88 10.5L17.5 12.12V15.5H14.5V10.5H15.88ZM22 8V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18L2.01 6C2.01 4.9 2.9 4 4 4H10L12 6H20C21.1 6 22 6.9 22 8ZM19 11.5L16.5 9H13V17H19V11.5Z',
      key: '1nshh4',
    },
  ],
]);

export default SnippetFolder;
